import React from "react";
import MyStoreOrders from "./orders";

export default function UserStoreOrders() {
  return (
    <div className="store-page">
      <div>
        <MyStoreOrders />
      </div>
    </div>
  );
}
